const INIT_USER = 'INIT_USER';
const RESET_USER = 'RESET_USER';
const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export { INIT_USER as I, RESET_USER as R, UPDATE_USER_INFO as U };
//# sourceMappingURL=actionTypes-9fbd05b0.js.map
